/* Tribe & Trowel — LAUNCH redesign: global cart drawer (Shopify Cart AJAX), announcement rotation, welcome capture, sticky-bar helper.
   Ported 1:1 from design handoff tt-cart.js; prototype localStorage cart replaced with the real Shopify cart. */
(function () {
  var IMG = {
    packets: 'https://cdn.shopify.com/s/files/1/0762/3370/3469/files/8388d23d4c584df2a964a6c199cb2c1d_tplv-fhlh96nyum-crop-webp_844_844.webp?v=1782237330&width=200',
    bundle: 'https://cdn.shopify.com/s/files/1/0762/3370/3469/files/50127218-215A-4353-ABDB-47DE77C3E58D.png?v=1782763333&width=200',
    herbs: 'https://cdn.shopify.com/s/files/1/0762/3370/3469/files/78aaac234278405c9fcf027f185f1902_tplv-fhlh96nyum-crop-webp_1080_1080.webp?v=1782194652&width=200',
    melon: 'https://cdn.shopify.com/s/files/1/0762/3370/3469/files/melon.jpg?v=1782195688&width=200',
    monarch: 'https://cdn.shopify.com/s/files/1/0762/3370/3469/files/4ca5ef8c4aa340d4a6453e5cdb2747d0_tplv-fhlh96nyum-crop-webp_1080_1080.webp?v=1782194589&width=200',
    library: 'https://cdn.shopify.com/s/files/1/0762/3370/3469/files/654548c1-ef58-477a-b459-1aa18306123e.png?v=1782807051&width=200'
  };
  var TRIBE_ID = 66912071155757, TRIBE_PLAN = 5089034285, GOAL = 50;
  var cart = { items: [], item_count: 0, items_subtotal_price: 0 };
  var fmt = function (v) { return '$' + v.toFixed(2); };

  function refreshCounts() {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var host = document.getElementById('tt-drawer-host');
    if (host && host.renderDrawer) host.renderDrawer();
  }
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; refreshCounts(); return c; })
      .catch(function () {});
  }
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function () { return fetchCart(); });
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (c) { cart = c; refreshCounts(); })
      .catch(function () { fetchCart(); });
  }
  window.TT2Cart = { fetch: fetchCart, add: addItems, open: function () { var h = ensureHost(); h.open(); } };

  var chipsTpl = null;
  function chipsHTML() {
    if (chipsTpl === null) {
      var t = document.getElementById('tt2-chips-tpl');
      chipsTpl = t ? '<div class="tt2-chips">' + t.innerHTML + '</div>' : '';
    }
    return chipsTpl;
  }

  function drawerHTML(open) {
    var count = cart.item_count || 0;
    var subtotal = (cart.items_subtotal_price || 0) / 100;
    var left = Math.max(0, GOAL - subtotal);
    var pct = Math.min(100, subtotal / GOAL * 100).toFixed(1);
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.variant_id] = true; });
    var rows = (cart.items || []).map(function (it) {
      var linePrice = (it.final_line_price != null ? it.final_line_price : it.line_price) / 100;
      var isFree = linePrice === 0;
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=112' : IMG.packets;
      var name = it.product_title + (it.variant_title && it.variant_title !== 'Default Title' && it.variant_title !== 'Default' ? ' — ' + it.variant_title : '');
      var ctrl = isFree
        ? '<span data-del="' + it.key + '" title="Remove" style="cursor:pointer;font-weight:800;font-size:13px;color:var(--color-neutral-600);background:var(--color-neutral-100);border:1px solid var(--color-neutral-300);border-radius:999px;padding:4px 12px">✕</span>'
        : '<div style="display:flex;align-items:center;gap:10px;background:var(--color-neutral-100);border:1px solid var(--color-neutral-300);border-radius:999px;padding:4px 10px">' +
          '<span data-dec="' + it.key + '" style="cursor:pointer;font-weight:800;font-size:15px;color:var(--color-accent-700);width:14px;text-align:center">−</span>' +
          '<span style="font-weight:800;font-size:13px;min-width:14px;text-align:center">' + it.quantity + '</span>' +
          '<span data-inc="' + it.key + '" style="cursor:pointer;font-weight:800;font-size:15px;color:var(--color-accent-700);width:14px;text-align:center">+</span></div>';
      return '<div style="display:flex;gap:12px;align-items:center;padding:9px 0;border-bottom:1px solid var(--color-neutral-300)">' +
        '<img src="' + img + '" alt="" style="width:56px;height:56px;border-radius:11px;object-fit:cover;flex-shrink:0">' +
        '<div style="flex:1;min-width:0"><div style="font-weight:800;font-size:13.5px;line-height:1.35">' + name + '</div>' +
        '<div style="font-size:12.5px;color:var(--color-neutral-700);margin-top:2px">' + (isFree ? '<span style="color:var(--color-accent-2-800);font-weight:800">FREE GIFT</span>' : fmt(linePrice)) + '</div></div>' +
        ctrl + '</div>';
    }).join('');
    var tribeCard = inCart[TRIBE_ID] ? '' :
      '<div style="background:var(--color-accent-2-900);border-radius:14px;padding:12px 14px;margin:12px 0;-webkit-font-smoothing:antialiased">' +
      '<div style="font-weight:800;font-size:13.5px;color:var(--color-neutral-100)">The Tribe — Founding Membership</div>' +
      '<div style="font-size:12px;color:var(--color-accent-2-300);margin:3px 0 8px">$650 library free · expert support · 15% off · $199/yr locked for life</div>' +
      '<span data-add-tribe style="display:block;text-align:center;cursor:pointer;border-radius:999px;padding:8px 14px;font-size:12.5px;font-weight:800;background:var(--color-accent);color:var(--color-neutral-100)">Join The Tribe · $199/yr</span></div>';
    var shipMsg = count === 0 ? '' : (left > 0
      ? '<div style="font-size:13.5px;margin-bottom:8px">You&rsquo;re <strong style="color:var(--color-accent-700)">' + fmt(left) + '</strong> away from <strong>FREE U.S. shipping</strong></div>'
      : '<div style="font-size:13.5px;font-weight:800;color:var(--color-accent-2-800);margin-bottom:8px">✓ FREE U.S. shipping unlocked!</div>');
    return '<div data-close style="position:fixed;inset:0;background:rgba(32,30,29,.45);z-index:90;transition:opacity .3s ease;opacity:' + (open ? 1 : 0) + ';pointer-events:' + (open ? 'auto' : 'none') + '"></div>' +
      '<div style="position:fixed;top:0;right:0;bottom:0;width:420px;max-width:92vw;background:var(--color-bg);z-index:95;box-shadow:var(--shadow-lg);display:flex;flex-direction:column;transition:transform .35s ease;transform:' + (open ? 'translateX(0)' : 'translateX(105%)') + '">' +
      '<div style="display:flex;justify-content:space-between;align-items:center;padding:13px 22px;border-bottom:1px solid var(--color-neutral-300)">' +
      '<div style="font-family:var(--font-heading);font-size:22px">Your cart <span style="font-family:var(--font-body);font-size:13px;font-weight:700;color:var(--color-neutral-700)">· ' + count + ' item' + (count === 1 ? '' : 's') + '</span></div>' +
      '<button data-close style="border:none;background:var(--color-neutral-200);cursor:pointer;width:32px;height:32px;border-radius:50%;font-size:16px;font-family:var(--font-body)">✕</button></div>' +
      '<div style="padding:11px 22px 9px;background:var(--color-neutral-100);border-bottom:1px solid var(--color-neutral-300)">' + shipMsg +
      '<div style="position:relative;height:13px;border-radius:999px;background:var(--color-neutral-200);overflow:hidden"><div style="position:absolute;top:0;left:0;bottom:0;border-radius:999px;width:' + pct + '%;transition:width .6s cubic-bezier(.22,1,.36,1);background:repeating-linear-gradient(-55deg,var(--color-accent-2-700) 0 12px,color-mix(in srgb,var(--color-accent-2-700) 88%,white) 12px 24px);background-size:200% 100%;animation:ttshimmer2 12s linear infinite"></div></div>' +
      '<div style="display:flex;justify-content:space-between;font-size:11px;font-weight:700;color:var(--color-neutral-600);margin-top:5px"><span>$0</span><span>$50 · FREE shipping</span></div></div>' +
      '<div style="flex:1;overflow-y:auto;padding:10px 22px">' +
      (count === 0 ? '<div style="text-align:center;padding:28px 0;color:var(--color-neutral-700)"><div style="font-family:var(--font-heading);font-size:20px;color:var(--color-text);margin-bottom:6px">Your cart is empty</div><div style="font-size:13.5px">Add something below to get growing.</div></div>' : rows) +
      tribeCard + '</div>' +
      '<div style="padding:11px 22px 13px;border-top:1px solid var(--color-neutral-300);background:var(--color-neutral-100)">' +
      '<div style="display:flex;justify-content:space-between;font-size:14.5px;font-weight:800;margin-bottom:8px"><span>Subtotal</span><span>' + fmt(subtotal) + '</span></div>' +
      '<a href="/checkout" class="btn btn-primary btn-block" style="text-decoration:none;font-family:var(--font-body);font-size:16px;font-weight:800;letter-spacing:0;padding:13px 24px;margin-top:0;-webkit-font-smoothing:antialiased">Checkout · ' + fmt(subtotal) + '</a>' +
      '<div style="text-align:center;font-size:11px;color:var(--color-neutral-600);margin-top:7px">Secure checkout · Sprout No Doubt Guarantee</div>' + chipsHTML() + '</div></div>';
  }

  var host = null;
  function ensureHost() {
    if (host) return host;
    host = document.createElement('div');
    host.id = 'tt-drawer-host';
    host.isOpen = false;
    host.renderDrawer = function () { host.innerHTML = drawerHTML(host.isOpen); };
    host.open = function () { host.isOpen = true; host.renderDrawer(); };
    host.addEventListener('click', function (e) {
      var t = e.target.closest('[data-close],[data-inc],[data-dec],[data-del],[data-add],[data-add-tribe]');
      if (!t) return;
      if (t.hasAttribute('data-close')) { host.isOpen = false; host.renderDrawer(); }
      else if (t.hasAttribute('data-inc') || t.hasAttribute('data-dec')) {
        var key = t.getAttribute('data-inc') || t.getAttribute('data-dec');
        var line = (cart.items || []).filter(function (it) { return it.key === key; })[0];
        if (line) changeLine(key, line.quantity + (t.hasAttribute('data-inc') ? 1 : -1));
      }
      else if (t.hasAttribute('data-del')) changeLine(t.getAttribute('data-del'), 0);
      else if (t.hasAttribute('data-add-tribe')) addItems([{ id: TRIBE_ID, quantity: 1, selling_plan: TRIBE_PLAN }]);
      else if (t.hasAttribute('data-add')) addItems([{ id: parseInt(t.getAttribute('data-add'), 10), quantity: 1 }]);
    });
    document.body.appendChild(host);
    host.renderDrawer();
    return host;
  }

  document.addEventListener('click', function (e) {
    var addEl = e.target.closest('[data-cart-add]');
    var multiEl = e.target.closest('[data-cart-add-multi]');
    var openEl = e.target.closest('[data-cart-open]');
    if (!addEl && !openEl && !multiEl) return;
    e.preventDefault();
    var h = ensureHost();
    if (addEl) {
      var id = parseInt(addEl.getAttribute('data-cart-add'), 10);
      var item = { id: id, quantity: 1 };
      if (id === TRIBE_ID) item.selling_plan = TRIBE_PLAN;
      addItems([item]).then(function () { h.open(); });
    } else if (multiEl) {
      try { addItems(JSON.parse(multiEl.getAttribute('data-cart-add-multi'))).then(function () { h.open(); }); } catch (err) {}
    } else h.open();
  });
  document.addEventListener('DOMContentLoaded', function () { fetchCart(); });
  window.addEventListener('pageshow', function () { fetchCart(); });

  /* --- rotating, clickable announcement bar --- */
  var MSGS = [
    { t: '★ Free U.S. shipping on orders over $50', href: '/collections/add-on-seed-packs' },
    { t: '90-Day Sprout No Doubt Guarantee — on every order', href: '/products/33-pack-heirloom-vegetable-seed-bank' },
    { t: 'The Tribe: the $650 library free + expert support →', href: '/products/the-tribe-founding-membership' }
  ];
  setTimeout(function () {
    var bar = document.querySelector('.tt-announce');
    if (!bar) return;
    var i = 0;
    bar.addEventListener('click', function () { location.href = MSGS[i].href; });
    setInterval(function () {
      bar.style.opacity = '0';
      setTimeout(function () { i = (i + 1) % MSGS.length; bar.textContent = MSGS[i].t; bar.style.opacity = '1'; }, 400);
    }, 6000);
  }, 1500);

  /* --- mobile menu drawer --- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { document.body.classList.add('tt2-menu-open'); }
    else if (e.target.closest('[data-menu-close]')) { document.body.classList.remove('tt2-menu-open'); }
  });

  /* --- one-time welcome / exit capture (markup rendered in layout, #tt2-welcome) --- */
  function showWelcome() {
    try {
      if (localStorage.getItem('tt-welcome')) return;
      localStorage.setItem('tt-welcome', '1');
    } catch (e) { return; }
    var w = document.getElementById('tt2-welcome');
    if (!w) return;
    w.style.display = 'block';
    w.addEventListener('click', function (e) { if (e.target.closest('[data-w-close]')) w.style.display = 'none'; });
  }
  setTimeout(function () {
    document.addEventListener('mouseleave', function (e) { if (e.clientY < 10) showWelcome(); });
    setTimeout(showWelcome, 45000);
  }, 8000);

  /* --- sticky bar helper: [data-sticky-show="950"] gains .is-on past that scrollY --- */
  var stickies = null;
  function onScroll() {
    if (!stickies) stickies = Array.prototype.slice.call(document.querySelectorAll('[data-sticky-show]'));
    stickies.forEach(function (el) {
      el.classList.toggle('is-on', window.scrollY > parseInt(el.getAttribute('data-sticky-show'), 10));
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('DOMContentLoaded', onScroll);
})();
